import SearchIcon from '@/assets/svgs/search-icon.svg'
import Input from '@/components/Input'
import PropTypes from 'prop-types'

const Search = ({
  name,
  value,
  placeholder,
  variant = 'outlined',
  disabled = false,
  onCancel,
  onChange,
}) => {
  return (
    <Input
      placeholder={placeholder ?? 'Search'}
      name={name ?? 'search'}
      value={value}
      prefixIcon={<img src={SearchIcon} alt="Search" style={{ width: '16px', height: '16px' }} />}
      onCancel={onCancel}
      onChange={onChange}
      variant={variant}
      disabled={disabled}
    />
  )
}

Search.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  variant: PropTypes.oneOf(['outlined', 'filled']),
  disabled: PropTypes.bool,
  onCancel: PropTypes.func,
  onChange: PropTypes.func,
}

export default Search
